import { render, staticRenderFns } from "./SelectModal.vue?vue&type=template&id=2228b0c8&"
import script from "./SelectModal.vue?vue&type=script&lang=js&"
export * from "./SelectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports